// extracted by mini-css-extract-plugin
export default {"wrapper":"CallButton_wrapper__GICll","icon":"CallButton_icon__HO2iv"};